//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, ContentTypeGroup } from '@constants'
import polling from '~/mixins/poll-when-visible'

const JUST_IN_ARTICLES = gql`
  query ($first: Int, $where: ArticleFilterInput, $order: [ArticleSortInput!]) {
    articles(first: $first, where: $where, order: $order) {
      nodes {
        id
        externalId
        date
        title
        slug
        contentType {
          id
          name
          contentTypeGroup {
            id
            name
          }
        }
      }
    }
  }
`

export default {
  name: 'JustInSidebar',
  mixins: [polling],
  props: {
    background: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      articles: [],
      animated: true,
      showPlaceholder: true,
      placeholders: 2,
      hide: false
    }
  },
  fetchOnServer: true,
  async fetch() {
    await this.refresh()
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    cardClass() {
      const classes = []

      if (this.background) classes.push(this.background)
      if (this.customClass) classes.push(this.customClass)

      return classes.join(' ')
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
    }
  },
  mounted() {
    if (this.$nuxt.context.isClient) {
      this.startPolling(() => this.refresh(true, false), 5 * 60 * 1000)
    }
  },
  methods: {
    isToday(date) {
      return this.$dayjs(date).isSame(this.$dayjs(), 'day')
    },
    async refresh(purge = false, showPlaceholders = true) {
      this.showPlaceholder = showPlaceholders

      const where = {
        contentType: {
          contentTypeGroupId: {
            neq: ContentTypeGroup.PARTNER_CONTENT
          }
        }
      }

      if (this.languageId != null) {
        where.languageId = {
          eq: this.languageId
        }
      }

      try {
        const { data } = await this.$apollo.query({
          query: JUST_IN_ARTICLES,
          variables: {
            first: 4,
            where,
            order: [
              {
                date: 'DESC'
              }
            ]
          },
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        if (!data) {
          this.hide = true
          return
        }

        this.articles = data.articles.nodes
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    }
  }
}
